/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type LotCurrency = "CHF" | "EUR" | "GBP";
import type { FragmentReference } from "relay-runtime";
declare export opaque type lotPrice_product$ref: FragmentReference;
declare export opaque type lotPrice_product$fragmentType: lotPrice_product$ref;
export type lotPrice_product = {|
  +currency: ?LotCurrency,
  +offerType: ?string,
  +rentNet: ?number,
  +salePrice: ?number,
  +$refType: lotPrice_product$ref,
|};
export type lotPrice_product$data = lotPrice_product;
export type lotPrice_product$key = {
  +$data?: lotPrice_product$data,
  +$fragmentRefs: lotPrice_product$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "lotPrice_product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rentNet",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePrice",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'e4632baf49473938847bdc54097833c3';

export default node;
